<template>
	<div class="page-header" _cursor="pointer">
		<div class="breadcrumb" v-if="levels.length > 0">
			<svg
				class="icon"
				aria-hidden="true"
				_transition="duration-300"
				:style="{
					outline: 'none',
					boxShadow: 'none',
					transform: $store.state.isCollapse ? 'rotate(0)' : 'rotate(180deg)'
				}"
				@click="isCollapse"
			>
				<use xlink:href="#icon-fanlen" style="color: #747474;"></use>
			</svg>
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item v-for="(lvl, idx) in levels" :key="idx" :to="goTarget(lvl)">{{
					lvl.name.indexOf('课件管理') != -1 || lvl.name.indexOf('素材管理') != -1 ? `${lvl.name} - ${subject}` : `${lvl.name}`
				}}</el-breadcrumb-item>
			</el-breadcrumb>
			<!-- <svg class="icon red" aria-hidden="true" fill="currentColor">
				<use xlink:href="#icon-juxing" class="red" className='test-name'></use>
			</svg> -->
		</div>
		<div>
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		levels: Array
	},
  watch: {
    $route: {
      handler(val) {
        if (val.params?.sbid == 1) {
          this.subject = '音乐'
        }
        if (val.params?.sbid == 2) {
          this.subject = '美术'
        }
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      subject: ''
    }
  },
	methods: {
		goTarget(lvl) {
			return lvl.to && this.$route.name == lvl.to.name ? null : lvl.to
		},
		isCollapse() {
			this.$store.commit('isCollapseChange')
		}
	}
}
</script>
<style lang="scss">
svg path {
	fill: inherit;
}
.red {
	color: #ff5e2a !important;
}
.page-header {
	padding: 20px 15px 20px 0;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	justify-content: space-between;

	.breadcrumb {
		position: relative;
		display: flex;
		border-radius: 2px 0 0px 2px;
		height: 20px;

		.el-breadcrumb {
			font-size: 18px;
			font-weight: 500;

			margin: 0;
			padding: 0 11px;
			.el-breadcrumb__inner.is-link {
				color: rgb(245, 0, 0);
			}
		}

		.el-breadcrumb__item:last-child .el-breadcrumb__inner {
			width: 136px;
			height: 28px;
			font-size: 16px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #858585;
			line-height: 24px;
			-webkit-background-clip: text;
			text-overflow: ellipsis;
			white-space: nowrap;
			overflow: hidden;
		}

		svg {
			font-size: 22px;
			/* position: absolute;


			right: -32px; */
		}
	}
}
</style>
